import { gql } from "@apollo/client";

export const SEARCH_SYMBOLS = gql`
  query SearchSymbols($query: String!) {
    searchSymbols(query: $query)
  }
`;
